import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "typographies-paragraph-medium-regular scheduled-emails-batch-delete-confirm-dialog__description" }

import { ref } from 'vue';

interface Props {
    emailsCount: number;
    isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduledEmailsBatchDeleteConfirmDialog',
  props: {
    emailsCount: {},
    isLoading: { type: Boolean, default: false }
  },
  emits: ["confirm", "close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const showModal = ref<boolean>(true);

const handleConfirm = (): void => {
    emit('confirm');
};

const closeModal = (): void => {
    showModal.value = false;
    emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_CompassModal = _resolveComponent("CompassModal")!

  return (_openBlock(), _createBlock(_component_CompassModal, {
    visible: showModal.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    size: _ctx.CompassEnums.ModalSize.SMALL,
    title: _ctx.$t.__('email.ScheduledEmailListing.batchDeleteConfirmModal.title'),
    closeOnClickOverlay: false,
    class: "scheduled-emails-batch-delete-confirm-dialog",
    primaryAction: {
            label: _ctx.$t.__('common.actions.delete'),
            loading: __props.isLoading,
            type: _ctx.CompassEnums.ButtonType.PRIMARY_DESTRUCTIVE,
            action: () => handleConfirm(),
        },
    secondaryActions: [
            {
                label: _ctx.$t.__('common.actions.cancel'),
                disabled: __props.isLoading,
                action: () => closeModal(),
            },
        ],
    onClosed: closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t.n__(
                    'email.ScheduledEmailListing.batchDeleteConfirmModal.description',
                    null,
                    __props.emailsCount,
                    __props.emailsCount,
                )), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "size", "title", "primaryAction", "secondaryActions"]))
}
}

})